import React, { useState } from 'react';
import { DI_ZHI } from '../utils/baziData';
import { ElementBadge } from '../components/ElementBadge';
import { Lightbulb } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const CangGan: React.FC = () => {
  const [activeBranch, setActiveBranch] = useState<string | null>(null);
  return <div className="space-y-12" data-id="element-96">
      <div className="text-center mb-10" data-id="element-97">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-98">
          地支藏干
        </h1>
        <p className="text-ink-light" data-id="element-99">
          地支如同大地，内部蕴含着天干的能量，称为"藏干"。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-100">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-101">
          <Lightbulb size={24} data-id="element-102" />
        </div>
        <div data-id="element-103">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-104">
            小白记忆法：经典口诀
          </h3>
          <p className="text-ink-light text-sm leading-relaxed font-serif" data-id="element-105">
            子藏癸水在其中，丑癸辛金己土同。
            <br data-id="element-106" />
            寅藏甲木和丙戊，卯中乙木独相逢。
            <br data-id="element-107" />
            辰藏乙木兼戊癸，巳中庚金有丙戊。
            <br data-id="element-108" />
            午藏丁火并己土，未中乙木加己丁。
            <br data-id="element-109" />
            申藏戊土庚并壬，酉中辛金独丰隆。
            <br data-id="element-110" />
            戌藏辛金及丁戊，亥藏壬甲是真踪。
          </p>
        </div>
      </div>

      <section className="space-y-6" data-id="element-111">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-112">
          互动探索：点击地支查看藏干
        </h2>
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-113">
          {DI_ZHI.map((branch, idx) => <div key={idx} onClick={() => setActiveBranch(activeBranch === branch.name ? null : branch.name)} className={`bg-white ink-border p-4 rounded-lg flex flex-col items-center text-center cursor-pointer transition-all duration-300
                ${activeBranch === branch.name ? 'ring-2 ring-gold shadow-md scale-105' : 'hover:border-gold/50 hover:shadow-sm'}`} data-id="element-114">
              <ElementBadge char={branch.name} element={branch.element} size="lg" className="mb-2" data-id="element-115" />

              <AnimatePresence data-id="element-116">
                {activeBranch === branch.name && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="mt-3 pt-3 border-t border-paper-dark w-full flex flex-col gap-1" data-id="element-117">
                    <span className="text-xs text-ink-light mb-1" data-id="element-118">藏干</span>
                    <div className="flex justify-center gap-1" data-id="element-119">
                      {branch.hiddenStems.map((hs, i) => <span key={i} className="font-bold text-sm bg-paper px-1.5 py-0.5 rounded text-ink" data-id="element-120">
                          {hs}
                        </span>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </section>
    </div>;
};